import { EZoneCategory, SiteEntryProps } from '@ixicare/resources';
import { Input, LivingUnitSelect, SubmitButton } from '@ixicare/ui';
import * as React from 'react';
import { t } from '~i18n';
import { ZoneCategorySelect } from '../components/ZoneCategorySelect';
import { useLivingUnitSelect } from '../hooks/useLivingUnitSelect';

interface DrawToolCreateContainerProps {
  site: SiteEntryProps;
  onCreate: (body: { name: string; livingUnitId?: string; category?: EZoneCategory }) => void;
  hasDrawing: boolean;
}

const DrawToolCreateContainer: React.FC<DrawToolCreateContainerProps> = ({ site, onCreate, hasDrawing }) => {
  const [name, setName] = React.useState('');
  const [isNameTouched, setIsNameTouched] = React.useState(false);
  const [frozen, setFrozen] = React.useState(false);
  const [category, handleCategoryChange] = React.useState<EZoneCategory>();

  const { options, livingUnits, livingUnitId, livingUnitName, createLuMutation, handleCreateOption, onChange } =
    useLivingUnitSelect({ site });

  React.useEffect(() => {
    const timer = setTimeout(() => setFrozen(false), 3000);
    return () => clearTimeout(timer);
  }, [frozen]);

  React.useEffect(() => {
    if (!livingUnitName || !category) return;
    if (!isNameTouched) {
      setName(`${t(`zone.category.${category}`)} ${livingUnitName}`);
    }
  }, [category, livingUnitName]);

  const handleSubmit = React.useCallback(
    (e) => {
      setFrozen(true);
      e.preventDefault();
      onCreate({ name, livingUnitId, category });
    },
    [onCreate, name, category, livingUnitId]
  );

  const disabled = !(!hasDrawing == false && !name == false && frozen == false);
  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-15">
        <LivingUnitSelect
          options={options}
          livingUnitId={livingUnitId}
          isLoading={livingUnits.isLoading || createLuMutation.isPending}
          onCreateOption={handleCreateOption}
          onChange={onChange}
        />
      </div>
      <div className="mb-15">
        <ZoneCategorySelect category={category} onChange={handleCategoryChange} />
      </div>
      <div className="mb-15">
        <Input
          label="Description"
          value={name}
          onChange={(e) => {
            setName(e.currentTarget.value);
            setIsNameTouched(true);
          }}
        />
      </div>
      <div className="mb-15">
        <SubmitButton disabled={disabled} isBlock>
          {t('drawtool.sidepanel.button.create')}
        </SubmitButton>
      </div>
    </form>
  );
};

export default DrawToolCreateContainer;
